/* eslint-disable no-mixed-spaces-and-tabs */
import { Box, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import LoadingButton from "../../../../../design/wilya-loading-button";

interface ActionButtonsProps {
	handleClose: () => void;
	cancelShiftWithReasonStatus: string;
	cancelShiftForm: any;
	handleCancelShift: (shiftId: number) => void;
	shiftData: {
		id: number;
	};
}

const ActionButtons = ({
	handleClose,
	cancelShiftWithReasonStatus,
	cancelShiftForm,
	handleCancelShift,
	shiftData,
}: ActionButtonsProps) => {
	const { t } = useTranslation();
	return (
		<Box mt={2} display='flex' justifyContent='flex-end'>
			<Button
				variant='text'
				color='primary'
				onClick={handleClose}
				sx={{ marginRight: "16px" }}
			>
				{t("scheduler_keep-shift")}
			</Button>
			<LoadingButton
				variant='contained'
				color='primary'
				loading={cancelShiftWithReasonStatus === "pending"}
				disabled={
					cancelShiftForm
						? cancelShiftForm.messageToWorker.length > 150 ||
						  // cancelShiftForm.selectedReason === "" ||
						  (Number(cancelShiftForm.selectedReason) === -1 &&
								cancelShiftForm.otherReason === "")
						: true
				}
				onClick={() => {
					handleCancelShift && handleCancelShift(shiftData?.id);
				}}
			>
				{t("scheduler_cancel-shift")}
			</LoadingButton>
		</Box>
	);
};

export default ActionButtons;
